import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import MarketPriceSection from './components/MarketPriceSection';
import FAQSection from './components/FAQSection';
import AboutPreviewSection from './components/AboutPreviewSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="黄瓜网站 - 专业黄瓜种植与交易平台 | 种植技术、品种大全、市场行情"
        description="黄瓜网站是专注黄瓜种植技术、品种选育、市场行情与产品交易的一站式平台。为黄瓜种植户、经销商和农业爱好者提供最新种植指南、病虫害防治、价格行情及优质货源对接服务。涵盖黄瓜种植技术、黄瓜品种大全、黄瓜市场行情。"
        keywords="黄瓜网站,黄瓜种植技术,黄瓜品种大全,黄瓜市场行情,黄瓜批发价格,黄瓜病虫害防治,黄瓜种子选购"
        canonicalUrl="https://www.huanggua.site"
      />

      <header>
        <Navbar />
        <HeroSection />
      </header>

      <main>
        <CategorySection />
        <ArticleSection />
        <MarketPriceSection />
        <FAQSection />
        <AboutPreviewSection />
      </main>

      <Footer />
    </>
  );
}